import HistoryApi from './HistoryApi';
export default HistoryApi;